import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  createSession,
  navigationUrl,
} from '../../../../store/analytic/actions';

import { selectContact } from '../../../../store/contacts/actions';
import moment from 'moment';
import {
  generateToken,
  tokenSentTimeAction,
} from '../../../../store/auth/actions';
import Telephone from '../../../../components/Cards/Telephone';
import Email from '../../../../components/Cards/Mail';
import WhatsAppCard from '../../../../components/Cards/Telephone/WhatsApp';
import UseContactPhone from '../../../../components/Cards/Telephone/UseContactPhone';

import SmsCard from '../../../../components/Cards/Telephone/Sms';
import { getContacts } from '../../../../store/contacts/actions';
import styled from 'styled-components';
interface IParams {
  cpf: string;
}
interface ItwoFactor {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setInfo: React.Dispatch<React.SetStateAction<string>>;
  useTwoFactor: boolean;
}
// Ese componente está péssimo. Precisa urgente de refatoração. Eu o extraí de outro componente para permitir multiplias maneiras de validação, mas isto não foi criado por mim.
const TwoFactorValidation: React.FC<ItwoFactor> = ({
  setLoading,
  useTwoFactor,
  setInfo,
}) => {
  const dispatch = useDispatch();
  const [selectedContactInfo, setSelectedContactInfo] = useState<
    ContactOption
  >();
  const { cpf }: IParams = useParams();

  const { contacts, useWhatsappToken, useSMSToken } = useSelector(
    (state: ApplicationState) => ({
      contacts: state.contacts.list || [],
      useWhatsappToken: state.config.enviaTokenWhatsapp === 'true',
      useSMSToken: state.config.enviaTokenSMS === 'true',
      useContact: state.config.validacaoAcesso === '25' ? true : false,
    })
  );
  const useBothToToken = useWhatsappToken && useSMSToken;
  const onlyUseWhatsToken = useWhatsappToken && !useSMSToken;
  const onlyUseSMSToken = !useWhatsappToken && useSMSToken;

  const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    h4 {
      align-self: center;
      color: ${(props) => props.theme.colors.primaryDark1};
    }
  `;

  const handleGenerateToken = () => {
    setLoading(true);
    dispatch(generateToken.request());
    dispatch(tokenSentTimeAction(moment().toDate()));
  };
  useEffect(() => {
    dispatch(generateToken.failure('')); // apenas para mudar o status;
  }, [dispatch]);

  useEffect(() => {
    if (cpf) {
      dispatch(createSession.request('/'));
      dispatch(getContacts.request({ cpf }));
    }
    dispatch(
      navigationUrl.request({
        action: '/preencheuCPF ',
      })
    );
  }, [dispatch, cpf]);
  const selectFunction = useCallback(
    (type: string, contact: UserContact, obj: ContactOption) => {
      setSelectedContactInfo(obj);
      const isEmail = type === 'email';
      const isWhatsapp = type === 'whatsapp';
      const isSMS = type === 'sms';
      const dispatchContact = (type: GQL.ContactType) =>
        dispatch(selectContact({ ...contact, ...{ type } }));

      if (isEmail) {
        return dispatchContact('Email' as GQL.ContactType);
      } else if (isWhatsapp) {
        return dispatchContact('Whatsapp' as GQL.ContactType);
      } else if (isSMS) {
        return dispatchContact('Sms' as GQL.ContactType);
      }
    },
    [dispatch]
  );
  return (
    <Wrapper>
      {contacts.length > 0 && (
        <h4>
          {useTwoFactor
            ? 'Selecione um contato para o recebimento do token de acesso'
            : 'Selecione um contato para validação do acesso'}
        </h4>
      )}
      {contacts.map((contact) => {
        const { telephone: telephoneExists } = contact as ContactType &
          GQL.IEmail &
          GQL.ITelephone;
        if (telephoneExists) {
          const typeContact = contact as GQL.ITelephone;
          const { ddd_tel: DDD, telephone } = typeContact;
          const props = {
            setInfo: setInfo,
            key: `${typeContact.cod_tel}-${typeContact.databaseId}`,
            info: `(${DDD}) ${telephone}`,
            typeContact,
            selectFunction: (type: ContactOption['type']) => {
              selectFunction(type, typeContact, {
                type,
                idBase: typeContact!.databaseId,
                idContact: typeContact!.cod_tel!,
              });
            },
            isSelected:
              (selectedContactInfo?.type === 'sms' ||
                selectedContactInfo?.type === 'whatsapp') &&
              selectedContactInfo?.idContact === typeContact.cod_tel &&
              selectedContactInfo?.idBase === typeContact.databaseId,
            type: selectedContactInfo?.type,
            handleGenerateToken: handleGenerateToken,
            onkeypress: (e: { key: string }) =>
              e.key === 'Enter' && useTwoFactor
                ? handleGenerateToken()
                : setInfo(telephone),
          };
          if (!useTwoFactor) return <UseContactPhone {...props} />;
          else if (useBothToToken && useTwoFactor)
            return <Telephone {...props} />;
          else if (onlyUseWhatsToken && useTwoFactor)
            return <WhatsAppCard {...props} />;
          else if (onlyUseSMSToken && useTwoFactor)
            return <SmsCard {...props} />;
          return;
        } else {
          const typeContact = contact as GQL.IEmail;
          return (
            <Email
              useTwoFactor={useTwoFactor}
              key={typeContact.cod_email}
              info={typeContact.email}
              selected={
                selectedContactInfo?.type === 'email' &&
                selectedContactInfo?.idContact === typeContact.cod_email &&
                selectedContactInfo?.idBase === typeContact.databaseId
              }
              selectFunction={(type) => {
                selectFunction(type, typeContact, {
                  type: 'email',
                  idBase: typeContact.databaseId,
                  idContact: typeContact.cod_email!,
                });
              }}
              onkeypress={(e: { key: string }) =>
                e.key === 'Enter' && useTwoFactor
                  ? handleGenerateToken()
                  : setInfo(typeContact.email)
              }
            />
          );
        }
      })}
    </Wrapper>
  );
};

export default TwoFactorValidation;
